import { useEffect } from 'react';
import { MainHeader } from '../MainHeader';
import { Slidehsow } from '../slideshow';
import { Whatwedo } from '../whatwedo';
import { Map } from '../map';
import { WhatsAppWidget } from '../WhatsAppWidget';
import './styles.css';

const highlights = [
  ['Tailored Design', 'Every celebration is shaped around your style and story.'],
  ['Attention to Detail', 'From the first concept to the final finishing touch.'],
  ['Memorable Experiences', 'Beautiful spaces designed to feel as special as they look.'],
  ['Reliable Service', 'A hands-on team supporting you throughout your event journey.'],
];

export const HomePage = () => {
  useEffect(() => {
    document.title = "Ruesevents Designs - Home";
  }, []);

  return (
    <div id="home-container" className="page-shell">
      <MainHeader home={true} about={false} gallery={false} contact={false} />
      <Slidehsow />

      <section className="home-highlights">
        <div className="section-shell home-highlights-grid">
          {highlights.map(([title, text]) => (
            <div className="home-highlight" key={title}>
              <span className="home-highlight-mark" aria-hidden="true">◆</span>
              <div>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <Whatwedo />
      <Map />
      <WhatsAppWidget />
    </div>
  );
};
